import React, { Component, PropTypes } from 'react';
import { mixin, RefluxMixin, Authorizer } from 'Util';
import { RaisedButton, TextField, Styles } from 'material-ui';
import AuthActions from 'actions/Auth';
import AuthStore from 'stores/Auth';
import AppPage from 'components/AppPage';
import RulerBar from 'components/RulerBar';
import Suggest from 'components/Suggest';
import { withRouter } from 'react-router';

let { Spacing } = Styles;


class Incarnate extends mixin(RefluxMixin, Component) {
  static contextTypes = {
    getIntlMessage: PropTypes.func
  };

  listenToStores() {
    this.listenToStore(AuthStore);
  }

  incarnate() {
    const { router } = this.props;
    AuthActions.incarnate(parseInt(this.refs.userId.getValue(), 10), () => {
      router.replace('/dashboard');
    });
  }

  render() {
    return (
      <AppPage key="settings" header={<RulerBar />}>
        <div style={{ padding: Spacing.desktopGutterMini }}>
          <Suggest hintText="User id" ref="userId" endpoint={'mr.wolf-user'} />
          <RaisedButton
            onEnterKeyDown={::this.incarnate}
            fullWidth={true}
            secondary={true}
            style={{ zIndex: 2 }}
            label={this.context.getIntlMessage('Incarnate')}
            onTouchTap={::this.incarnate}
          />
        </div>
      </AppPage>
    );
  }
}

export default withRouter(Incarnate);



// WEBPACK FOOTER //
// ./src/js/components/Route/Incarnate.js